import Vue from 'vue'
import Router from 'vue-router'
import Recover from '@/views/login/recover'
import PasswordReset from '@/views/login/passwordReset'
import Login from '@/views/login/index'
import Layout from '@/components/layout/layout'
import Platform from '@/views/platform/platform'
import ChangeEmail from '@/views/platform/changeEmail'

Vue.use(Router);

import moduleRoutes from './modules';

export default new Router({
  mode: 'history',
  base: '/' + process.env.PUBLICPATH + '/fe/',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/recover',
      name: 'recover',
      component: Recover
    },
    {
      path: '/passwordReset',
      name: 'PasswordReset',
      component: PasswordReset
    },
    {
      path: '/',
      redirect: {name: 'platform'}
    },
    {
      path: '/platform',
      name: 'platform',
      component: Platform,
      meta: {powerBtn: false}
    },
    {
      path: '/change_email',
      name: 'change_email',
      component: ChangeEmail,
      meta: {powerBtn: false}
    },
    {
      path: '/index',
      name: 'index',
      redirect: {name: 'baseInfo'},
      meta: {powerBtn: true},
      component: Layout,
      children: [
        ...moduleRoutes
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js